import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { showBanner } from '../../global-state/banner-slice'
import { opportunityServices } from '../../services'
import { UnitPriceFormPresenter } from './unit-price-form-presenter'
import { useSearchParams } from 'react-router-dom'

const UnitPriceFormContainer = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') || 'general'
  console.log(type)
  const handleUnitPriceFiles = async (fileData: File[]) => {
    if (!fileData || fileData.length === 0) {
      dispatch(
        showBanner({
          text: 'Please select a CSV file to upload',
          variant: 'error-banner',
        }),
      )
      return
    }

    // Only process the first file if multiple are selected
    const file = fileData[0]

    // Check if it's a CSV file
    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      dispatch(
        showBanner({
          text: 'Please upload a valid CSV file',
          variant: 'error-banner',
        }),
      )
      return
    }

    try {
      // Set loading state to true before API call
      setIsLoading(true)

      // Create form data to directly upload to the endpoint
      const formData = new FormData()
      formData.append('file', file)
      if (type === 'client' || type === 'investor') {
        formData.append('options', JSON.stringify({ useInvestorFields: true }))
      }

      const response: any = await opportunityServices.postUnitPriceUpdateFile(formData)

      if (response.status === 200) {
        dispatch(
          showBanner({
            text: 'Unit prices updated successfully.',
            variant: 'success-banner',
          }),
        )
      } else {
        dispatch(
          showBanner({
            text:
              (response.data && response.data.message) ||
              'Something went wrong processing the file',
            variant: 'error-banner',
          }),
        )
      }
    } catch (error) {
      dispatch(
        showBanner({
          text: 'Error uploading file. Please try again.',
          variant: 'error-banner',
        }),
      )
    } finally {
      // Set loading state to false after API call completes (success or error)
      setIsLoading(false)
    }
  }

  return (
    <>
      {type === 'client' || type === 'investor' ? (
        <UnitPriceFormPresenter
          type={type}
          handleUnitPriceFiles={handleUnitPriceFiles}
          isLoading={isLoading}
        />
      ) : (
        <UnitPriceFormPresenter
          type={type}
          handleUnitPriceFiles={handleUnitPriceFiles}
          isLoading={isLoading}
        />
      )}
    </>
  )
}

export { UnitPriceFormContainer }
